var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Hero-Section'),_c('ExperienciasImperdibles',{attrs:{"experiencias":_vm.experienciasImperdibles}}),_c('PorqueViajar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }